import { useQuery } from '@tanstack/react-query';

import { ParentKey } from './keys';
import { ParentService } from './parentService';

export function useGetParents() {
  return useQuery({
    queryKey: [ParentKey.PARENTS],
    queryFn: () => ParentService.getParents().then((response) => response.data),
  });
}
